export default __webpack_public_path__ + "static/media/guardRailsCluster.6fb84ca4.svg";